import React, { Component } from 'react';
import Checkbox from 'material-ui/Checkbox';

class FormCheckbox extends Component {
    handleCheck = (event, value) => {
        const { name, onCheck } = this.props;

        onCheck(name, value);
    };

    render() {
        const { onCheck, ...props } = this.props;

        return <Checkbox onCheck={this.handleCheck} {...props} />;
    }
}

export default FormCheckbox;



// WEBPACK FOOTER //
// ./src/UI/FormCheckbox.js